<template>
  <div class="medicalRecord">
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
      <span>首页</span>>
      <span>典型病例库</span>
    </div>
    <!--病例库-->
    <a href="../../../static/teach.html" target="blank"></a>
    <div class="layout_left_m" v-if="!popShow">
      <div class="margin10_box medicalRecord_left">
        <collapse-medical-record @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                                 @delPerson="delPerson" @addPersonList="addPersonList" @personClick="personClick"
                                 @searchClick="searchClick" :personList="personList" :treeData="treeData"
                                 @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
        </collapse-medical-record>
      </div>
    </div>
    <div class="layout_right_m " v-if="!popShow">
      <div class="layout_right_inner_m ">
        <div class="for_width">
          <div class="margin10_box" >
            <div class="w96">
              <div style="height: 50px;line-height: 50px;">
                <div style="float: left;">
                  <el-button class="medical_btn" @click="_newMedicalRecord">添加病例</el-button>
                  <el-button class="medical_btn" @click="exportCaseList">导出</el-button>
                </div>
                <div style="float: right;width:240px;height: 24px;position:relative; margin:10px 0 0 0;">
                  <radius-input @searchClick="tableCaseList"></radius-input>
                </div>
              </div>
                <div class="person_table">
                  <p-table :head="personTableHead" :height="tableHeiht" :data="tableData"
                           :operation="personTableOperation" :dynamicOperationName="'courseWare'" :operationWidth="'140'" :autoheight="autoheight"
                           @_operation="_operation_"></p-table>
                 <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" :page-size="page.pageSize" @current-page="__currentPage" @page-size="__pageSize" style="margin-top:10px"></page>
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<alonebutton v-if="popShow"></alonebutton>-->
    <!--查看-->
    <div class="query_detail w98" v-if="popShow">
      <router-view></router-view>
    </div>
    <pops :show="pop" :width="'980px'" :title="'从本院影像中选择'" @closePop="closePop" :class="'mrDialog'">
      <pImage></pImage>
    </pops>
  </div>
</template>

<script type="text/ecmascript-6">
import router from "../../../../router";
import collapse from "@/components/common/collapse/collapse";
import tabs from "@/components/common/tabs/tabs";
import tree from "@/components/common/tree/tree";
import radiusInput from "@/components/common/radiusInput/radiusInput";
import page from "@/components/common/page/page";
import alonebutton from "@/components/common/button/aloneButton";
import medicalNews from "@/components/common/medicalNews/medicalNews";
import pTable from "@/components/common/tables/publicTable";
import upload from "@/components/common/upload/uploadFile1";
import pImage from "@/components/common/Image/imageSelection";
import pops from "@/components/common/pops/pop";
import collapseMedicalRecord from "@/components/common/collapseMedicalRecord/collapseMedicalRecord";
import http from "@/api/http";
import * as _ from "@/common/js/config";

export default {
  components: {
    collapseMedicalRecord,
    medicalNews,
    page,
    alonebutton,
    radiusInput,
    pTable,
    tree,
    tabs,
    collapse,
    upload,
    pImage,
    pops
  },
  watch: {
    popShow(c) {
      this.getTableList()
      this._getTreeData();
      this._getTreeData(1);
      this.personFlag = '0'
    }
  },
  data() {
    return {
      personFlag: '0',
      page: {
        total: 0,
        currentPage: 0,
        pageSize: 30
      },
      filterText: '',
      autoheight:this.getH(),
      activeName: "1",
      popShow: false,
      tableHeiht: 0,
      width: 0,
      tableData: [],
      pop: false,
      personTableHead: [
        {
          props: "caseName",
          label: "病例名称",
          width: "20%"
        },
        {
          props: "privateType",
          label: "访问权限",
          width: "10%"
        },
        {
          props: "caseSex",
          label: "性别",
          width: "10%"
        },
        {
          props: "caseAge",
          label: "年龄",
          width: "10%"
        },
        {
          props: "createDateStr",
          label: "创建时间",
          width: "20%"
        },
        {
          props: "creatorName",
          label: "创建人",
          width: "20%"
        }
      ],
      personTableOperation: [
        {
          operation: '',
          name: '查看',
          class: 'icon-chakan',
          title: '报告'
        },
        {
          operation: '',
          name: '修改',
          class: 'icon-bianji',
          title: '修改'
        },
        {
          operation: '',
          name: '删除',
          class: 'icon-shanchu',
          title: '报告'
        }
      ],
      rightTabActive: "1",
      personList: [],
      isPerson: false,
      treeData: [],
      allTreeData: [],
      showCheckBox: false,
      tabs: [
        { label: "公共分类", name: "0" },
        { label: "个人分类", name: "1" }
      ],
      rightTabs: [
        { label: "1.病例信息", name: "1" },
        { label: "2.关联影像", name: "2" },
        { label: "3.添加附件", name: "3" }
      ],
      titleList: [
        { title: "自定义分类", name: "4" },
        { title: "按诊断分类", name: "1" },
        { title: "按部位分类", name: "2" },
        { title: "按科室分类", name: "3" }
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.layout();
      this._routerEach();
      if (this.$route.path === "/Homepage/MedicalRecord") {
        this.popShow = false;
      } else {
        this.popShow = true;
      }
    }, 20);

      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      })
  },
  methods: {
    getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 50 - 50 - 15 //header + crumb + search + pages
    },
    __pageSize(payload) {
      this.page.pageSize = payload
      this.getTableList()
    },
    _routerEach() {
      router.beforeEach((to, from, next) => {
        if (from.name === "MedicalRecord") {
          this.popShow = true;
        } else {
          this.popShow = false;
        }
        next();
      });
    },
    _newMedicalRecord() {
      this.popShow = true;
      this.$router.push({ name: "newMedicalRecord",query: {'flag': this.personFlag}});
    },
    stepMove(num) {
      this.activeName = (this.activeName - 0 + num).toString();
      this.rightTabActive = (this.rightTabActive - 0 + num).toString();
    },
    _openScope() {
      this.pop = true;
    },
    closePop(payload) {
      this.pop = payload;
    },
    layout() {
      this.tableHeiht = document.getElementById("app").clientHeight - 205;
      // let [width, els, height] = [
      //   document.getElementById("app").clientWidth - 480 + "px",
      //   document.getElementsByClassName("for_width"),
      //   document.getElementsByTagName("body")[0].clientHeight - 120 + "px"
      // ];
      // for (let item of els) {
      //   item.style.width = width;
      //   item.style.height = height;
      // }
    },
    tabChange(payload) {
      if (this.personFlag === payload.name) {
        return false
      }
      this.checkedPerson = ''
      this.treeId = ''
      this.page.currentPage = 1
      this.filterText = ''
      this.personFlag = payload.name
      // console.log(this.oldPersonList)
      this.personList = this.oldPersonList
      if (payload.name === "1") {
        this.isPerson = true;
        this.showCheckBox = true;
      } else {
        this.isPerson = false;
        this.showCheckBox = false;
      }
      this.getTableList(payload.name)
      this._getTreeData();
    },
    rightTabChange(payload) {
      // console.log(payload);
      this.activeName = payload.name;
      this.rightTabActive = payload.name;
    },
    _getTreeData(privateType = 0, keyWord='', subType) {
      let parmars = {
        privateType,
        keyWord,
        subType
      };
      http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
        if (res.data.code === _.ERR_OK) {
          if (privateType === 0) {
            this.allTreeData = res.data.model;
            this.changeColl('1')
          } else {
            this.oldPersonList = res.data.model;
            this.personList = res.data.model;
          }
        }
      });
    },
    changeColl(playlod) {
      this.filterText = ''
      this.treeData = []
      setTimeout(() => {
        // 1==>部位 2==>诊断 3==>科室
        let [flag, arr] = ['DIANOG', []];
        if (playlod === '1') {
          flag = 'DIANOG';
        } else if (playlod === '2') {
          flag = 'PART';
        } else if (playlod === '3') {
          flag = 'DEPT';
        } else {
          flag = 'CUSTOMER';
        }
        this.treeData = []
        arr = this.allTreeData.filter(item => item.subType === flag)
        for (let item of arr) {
          if (item.parentId === 0) {
            this.treeData.push({
              id: item.id,
              label: item.catalogName,
              children: this.allTreeData.filter(c => c.parentId ===  item.id)
            })
          }
        }
        for (let item of this.treeData) {
          if (item.children.length > 0) {
            for (let cItem of item.children) {
              cItem.label = cItem.catalogName
            }
          }
        }
      }, 400)
    },
    searchClick(val) {
      this.filterText = val
      this.personList = this.oldPersonList.filter(item => item.catalogName.indexOf(val) > -1)
    },
    treeNodeClick(val) {
      this.treeId = val.id
      this.page.currentPage = 1
      this.getTableList(this.personFlag, val.id)
    },
    personClick(val) {
      this.checkedPerson = val.id
      this.page.currentPage = 1
      this.getTableList(this.personFlag, val.id)
    },
    delPerson(val) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        let parmars = {
          id: val.id
        }
        http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            let id = this.treeId || this.checkedPerson || ''
            this._getTreeData(1, id);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addPersonList(val) {
      this.$prompt('请输入病例名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        let parmars = {
          privateType: '1',
          catalogName:　value
        }
        http.post('catalog/addCaseCatalog.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            this._getTreeData(1);
            this.$message({
              type: 'success',
              message: '提交成功'
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    getTableList(privateType=0,catalogId) {
      let parmars = Object.assign({
        catalogId,
        privateType,
        keyWord: this.tableKeyWords
      }, this.page)
      http.post('caselib/queryCaseList.json', parmars).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.tableData = res.data.model
          this.page.total = res.data.totalItem
          this.page.currentPage = res.data.currentPage
          for (let item of this.tableData) {
            item.caseSex = _.SEXOBJ[item.caseSex]
            item.privateType = _.privateType[item.privateType]
            if (item.caseAge === undefined) {
              item.ageUnit = ' '
              item.caseAge = ' '
            } else {
              if (item.ageUnit === '岁' || item.ageUnit === '4') {
                item.caseAge = item.caseAge + '岁'
              } else if (item.ageUnit === '3') {
                item.caseAge = item.caseAge + '月'
              } else if (item.ageUnit === '2') {
                item.caseAge = item.caseAge + '周'
              } else if (item.ageUnit === '5') {
                item.caseAge = item.caseAge + '小时'
              } else {
                item.caseAge = item.caseAge + '天'
              }
            }
          }
        }
      })
    },
    tableCaseList(val) {
      this.tableKeyWords = val
      this.getTableList(this.personFlag)
    },
    __currentPage(val) {
      this.page.currentPage = val
      let id = this.checkedPerson || this.treeId
      this.getTableList(this.personFlag, id)
    },
    exportCaseList() {
      let [catalogId,privateType,keyWord] = [this.treeId||this.checkedPerson||'',this.personFlag||'',this.tableKeyWords||'']
      // let url = `http://localhost:8080/edu_web/caselib/exportCaseList.json?catalogId=${catalogId}&privateType=${privateType}&keyWord=${keyWord}`
      let url = `${window.BASE_URL}caselib/exportCaseList.json?catalogId=${catalogId}&privateType=${privateType}&keyWord=${keyWord}`
      window.open(url)
    },
    _operation_(val) {
      if (val.operation.indexOf('chakan') > -1) {
        // console.log(val)
        this.$router.push({name: 'queryMedicalRecordInfo',params: {id: val.id}})
      } else if(val.operation.indexOf('bianji') > -1) {
        if (val.creator !== this.id) {
          return false
        }
        this.$router.push({ name: "updateMedicalRecord", query: {'aId': this.checkedPerson, 'flag': this.personFlag}, params: {id: val.id,aId: this.checkedPerson, flag: this.personFlag}});
      } else if (val.operation.indexOf('shanchu') > -1) {
        if (val.creator !== this.id) {
          return false
        }
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          http.post('caselib/deleteCase.json', {id: val.id}).then(res => {
            if (res.data.code === _.ERR_OK) {
              let id = this.treeId || this.checkedPerson || ''
              this.getTableList(this.personFlag, id)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  },
  created() {
    this.getH()
    this.layout()
    http.get('getUserInfo.json').then(res => {
      if (res.data.code === _.ERR_OK) {
        this.id = res.data.model.userId
      }
    })
    this._getTreeData();
    this._getTreeData(1);
    this.getTableList()
  }
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.w96 {
  width: 96%;
  margin: 0 auto;
}

.medicalRecord {
  width: 98%;
  margin: 0 auto;
  // background: #fff;
  overflow hidden !important;
}

.margin10_box {
  margin: 0 auto;
  background: #fff;
  height: calc(100vh - 104px);
  overflow-y: auto;
}

.layout_left_m {
  float: left;
  width: 300px;
  min-height: 100%;
}

.layout_right_m {
  float: left;
  width: 100%;
  min-height: 470px;
  margin-left: -300px;
  overflow: hidden;
}

.layout_right_inner_m {
  padding-left: 320px;
  width: 100%;
  min-height: 100%;
}

.arrow_first {
  position: relative;
  top: 26px;
  left: 80px;
}

.arrow_second {
  position: relative;
  top: 26px;
  left: 174px;
}

.medical_btn {
  background: #00abad;
  padding: 0 20px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.choose_btn {
  float: right;
  position: absolute;
  top: -35px;
  right: 0px;
  z-index: 100;
}

.person_table {
  height 100%
  margin-bottom: 0
  .el-table__header {
    height: 36px !important;
  }
}

.query_detail {
  // width: calc(100% - 180px);
  height: calc(100vh - 90px);
  width:98%
  position: absolute;
  top: 0;
  background:#f0f2f5;
}

.step_prev {
  margin-top: 10px;
  cursor: pointer;
  float: left;
}

.step_next {
  margin-top: 10px;
  cursor: pointer;
  float: right;
}
.for_width {
  width : calc(100% - 300px)
}

</style>



// WEBPACK FOOTER //
// medicalRecord.vue?504e8836